import React, { Fragment, useState, useEffect, useRef } from "react";
import { Input, DropDown } from '../core/Forms';
import Modal from '../core/Modal';
import { useApi } from '../../services/api';


function VerifyUser({ recoveryIntent, getRecoveryIntent }){
	const [ colegios, getColegios ] = useApi();
	const [ schools, getSchools ] = useApi();
	const [ programs, getPrograms ] = useApi();
	const [ program, setProgram ] = useState();

	const [ verifyUser, setVerifyUser ] = useState();
	const [ showColegios, setShowColegios] = useState();
	const [ showModal, setShowModal] = useState(false);

	const formSubmitted = useRef(false);

	useEffect( () => {
		// if(!recoveryIntent.data.erify_user){
		// 	return; }
		
		if(recoveryIntent.data.recovery_intent.verify_user.show_colegios){
			setShowColegios(true);
			getColegios('/api/v1/core/colegios');
		}else{
			getSchools('/api/v1/core/schools'); 
		}
	}, [recoveryIntent.data.recovery_intent.verify_user.show_colegios]);

	useEffect( () => {
		if(recoveryIntent.isError){
		}else if(recoveryIntent.isLoading){
		}else if(recoveryIntent.data.recovery_intent){
			const verify_user = recoveryIntent.data.recovery_intent.verify_user;
			
			setVerifyUser(verify_user);

			if(formSubmitted.current){
				setShowModal(true); }

			// if(verify_user.user_lock_ttl || verify_user.session_locked || verify_user.failed_attempts){
			// 	setShowModal(true);
			// }
		}
	}, [recoveryIntent]);


	function colegioChanged(colegioId){
		if(colegioId){
			getSchools(`/api/v1/core/schools?colegio_id=${colegioId}`);
			getPrograms();
		}else{
			getSchools();
			getPrograms();
		}
	}

	function schoolChanged(schoolId){
		if(schoolId){
			getPrograms(`/api/v1/core/schools/${schoolId}/programs`);
		}else{
			getPrograms();
		}
	}

	function programChanged(programId){
		if(!programId){
			setProgram(null); }

		programId = parseInt(programId);
		
		const program = programs.data.programs.find( 
			(program) => program.id == programId );
		
		setProgram(program);
	}

	function submitForm(event){
		event.preventDefault();

		const verify_user = {};

		for(let element of event.target.elements){
			if(element.name){
				verify_user[element.name] = element.value; }
		}

		getRecoveryIntent({ 
			url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
			method: 'PUT',
			data: { recovery_intent: { verify_user } } 
		});

		formSubmitted.current = true;

		return false;
	}

	let modalElement = null;
	
	if(showModal){
		if(verifyUser.user_lock_ttl){
			// alert(`Account Recovery Locked, try in ${verify_user.user_lock_ttl} seconds`);
			modalElement = (<Modal title="Verificación Bloqueada" setShowModal={setShowModal}>
				<p>Por seguridad hemos bloqueado la recuperación de esta cuenta, intenta más tarde ({verifyUser.user_lock_ttl} segundos).</p>
			</Modal>);
		}else if(verifyUser.session_locked){
			modalElement = (<Modal title="Verificación Bloqueada" setShowModal={setShowModal}>
				<p>Por seguridad hemos bloqueado la recuperación de esta cuenta, vuelve a intentar más tarde.</p>
			</Modal>);
		}else if(verifyUser.failed_attempts){
			modalElement = (<Modal title="Datos Incorrectos" setShowModal={setShowModal}>
				<p>Ups! No te hemos encontrado con los datos que nos proporcionaste. Revisa que estén bien escritos y vuelve a intentarlo.</p>
				<p>Si no funciona te recomendamos acudir a tu institución para revisar que estén correctos tus datos.</p>
			</Modal>);
		}
	}

	return (<Fragment>
		<h2>Verificamos tu identidad</h2>
		<p className="text-muted">Para recuperar tu acceso a Saeko completa el siguiente formulario,</p>

		<form onSubmit={submitForm}>
			
			{ showColegios ? <DropDown label="Colegio" 
				dataState={colegios} dataArrayKey="colegios" onChange={colegioChanged}
				description="Colegio representa la Entidad Federativa donde se encuentra tu plantel" /> : null}

			<DropDown name="school_id" label="Escuela" dataState={schools} dataArrayKey="schools" onChange={schoolChanged} />

			<DropDown name="program_id" label="Plan de Estudios" dataArrayKey="programs" dataState={programs} onChange={programChanged} />

			<Input name="name" label="Nombre"
				description="Puedes escribir tu nombre y apellidos con o sin acentos, pero la ñ será necesaria" />
			
			<div className="form-row">
				<Input name="first_surname" label="Apellido Paterno" className="form-group col-md-6" />
				<Input name="second_surname" label="Apellido Materno" className="form-group col-md-6" />
			</div>

			<div className="form-row">
				<Input name="student_id" label="Matrícula"
					description="Debe coincidir minúsculas y mayúsculas" className="form-group col-md-9" />
				
				{program && <Input name="grade_level" label={program.term_type_label} type="number" initialValue="0"
					className="form-group col-md-3" />}
			</div>

			<button type="submit" className="btn btn-primary w-100" disabled={recoveryIntent.isLoading}>
				{recoveryIntent.isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
				Verificar
			</button>
		</form>

		{modalElement}
	</Fragment>);
}

export default VerifyUser;
